import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function statsRoutes($stateProvider: StateProvider) {
    let publicStatsModule: { default: any; };
    let overallStatsModule: { default: any; };
    let zStatsModule: { default: any; };

    $stateProvider
        .state({
            name: 'public-stats',
            url: '/stats?fromDate&toDate&timeGranularity',
            params: {
                fromDate: {dynamic: true},
                toDate: {dynamic: true},
                timeGranularity: {dynamic: true}
            },
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => publicStatsModule.default,
            },
            lazyLoad: async () => {
                publicStatsModule = await import(/* webpackChunkName: "publicStats" */ './public/KpPublicStatsPage.svelte');
                return null;
            }
        })
        .state({
            name: 'dvk-stats',
            url: '/stats/dvk?fromDate&toDate&department&location',
            params: {
                fromDate: {dynamic: true},
                toDate: {dynamic: true},
                department: {dynamic: true},
                location: {dynamic: true}
            },
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => overallStatsModule.default,
            },
            lazyLoad: async () => {
                overallStatsModule = await import(/* webpackChunkName: "overallStats" */ 'src/features/stats/dvk/KpOverallStatsPage.svelte');
                return null;
            }
        })
        .state({
            name: 'z-stats',
            url: '/stats/z',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => zStatsModule.default,
            },
            lazyLoad: async () => {
                zStatsModule = await import(/* webpackChunkName: "zStats" */ './z-stats/KpZStats.svelte');
                return null;
            }
        });
}